(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => root.querySelectorAll('[data-catstrip-scroller]').forEach((track) => {
      if (track.dataset.scrollReady) return;
      const wrapper = track.closest('.catstrip');
      const prev = wrapper?.querySelector('[data-scroll-prev]');
      const next = wrapper?.querySelector('[data-scroll-next]');
      const nav = wrapper?.querySelector('[data-catstrip-nav]');
      if (!prev || !next) return;
      track.dataset.scrollReady = 'true';
      const update = () => {
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        if (nav) nav.hidden = track.scrollWidth <= track.clientWidth + 1;
      };
      const scroll = (direction) => {
        const card = track.querySelector('[data-card]');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const distance = (card?.getBoundingClientRect().width || track.clientWidth) + gap;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        track.scrollBy({ left: direction * distance, behavior });
      };
      prev.addEventListener('click', () => scroll(-1));
      next.addEventListener('click', () => scroll(1));
      track.addEventListener('scroll', update, { passive: true });
      const resize = new ResizeObserver(update);
      resize.observe(track);
      track._cleanupScroll = () => resize.disconnect();
      update();
    });
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-catstrip-scroller]').forEach((track) => track._cleanupScroll?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => root.querySelectorAll('.featuredcoll [data-scroller]').forEach((scroller) => {
      if (scroller.dataset.scrollReady) return;
      const track = scroller.querySelector('.featuredcoll__track');
      const prev = scroller.querySelector('[data-scroll-prev]');
      const next = scroller.querySelector('[data-scroll-next]');
      const nav = scroller.querySelector('.featuredcoll__nav');
      if (!track || !prev || !next) return;
      scroller.dataset.scrollReady = 'true';
      const update = () => {
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        if (nav) nav.hidden = track.scrollWidth <= track.clientWidth + 1;
      };
      const scroll = (direction) => {
        const item = track.querySelector('.featuredcoll__item');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const distance = (item?.getBoundingClientRect().width || track.clientWidth) + gap;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        track.scrollBy({ left: direction * distance, behavior });
      };
      prev.addEventListener('click', () => scroll(-1));
      next.addEventListener('click', () => scroll(1));
      track.addEventListener('scroll', update, { passive: true });
      const resize = new ResizeObserver(update);
      resize.observe(track);
      scroller._cleanupScroll = () => resize.disconnect();
      update();
    });
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.featuredcoll [data-scroller]').forEach((scroller) => scroller._cleanupScroll?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const header = document.querySelector("[data-header]");
  if (header && header.classList.contains("header--sticky")) {
    const onScroll = () => header.classList.toggle("is-scrolled", window.scrollY > 4);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-address-toggle]');
    if (!toggle) return;
    const newForm = document.querySelector('[data-address-form-new]');
    const targetId = toggle.dataset.addressEdit;
    if (targetId) {
      const editForm = document.getElementById('edit-address-' + targetId);
      if (editForm) editForm.style.display = editForm.style.display === 'none' ? 'block' : 'none';
    } else {
      const activeForm = toggle.closest('[data-address-form-new], [data-address-form-edit]');
      if (activeForm) {
        activeForm.style.display = 'none';
        const editId = activeForm.id.replace('edit-address-', '');
        const opener = activeForm.hasAttribute('data-address-form-edit')
          ? document.querySelector('[data-address-edit="' + editId + '"]') : document.querySelector('[data-address-new]');
        opener?.focus();
      } else if (newForm) {
        newForm.style.display = newForm.style.display === 'none' ? 'block' : 'none';
        if (newForm.style.display !== 'none') newForm.querySelector('input:not([type=hidden])')?.focus();
      }
    }
  });
  document.querySelectorAll('form[data-confirm]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      if (!confirm(form.dataset.confirm)) e.preventDefault();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  "use strict";

  /* Sufixa ids do formulário clonado (drawer mobile) para não duplicar com o desktop */
  function suffixCloneIds(root) {
    var map = {};
    if (root.id) { map[root.id] = root.id + "-mobile"; root.id = map[root.id]; }
    Array.from(root.querySelectorAll("[id]")).forEach(function (el) {
      map[el.id] = el.id + "-mobile";
      el.id = map[el.id];
    });
    Array.from(root.querySelectorAll("[for]")).forEach(function (el) {
      if (map[el.htmlFor]) el.htmlFor = map[el.htmlFor];
    });
    ["aria-describedby", "aria-labelledby", "aria-controls"].forEach(function (attr) {
      Array.from(root.querySelectorAll("[" + attr + "]")).forEach(function (el) {
        var next = el.getAttribute(attr).split(/\s+/).map(function (id) { return map[id] || id; });
        el.setAttribute(attr, next.join(" "));
      });
    });
  }

  function openFacetsDrawer(drawer, toggle) {
    var desk = document.querySelector("[data-facets]");
    var box = drawer.querySelector("[data-facets-mobile]");
    /* Clona a cada abertura (replaceChildren): reflete os filtros ativos sem duplicar ids/markup */
    if (box && desk) {
      var srcForm = desk.querySelector("[data-facet-form]");
      if (srcForm) {
        var clone = srcForm.cloneNode(true);
        suffixCloneIds(clone);
        box.replaceChildren(clone);
      }
    }
    drawer.__lastFocus = toggle || document.activeElement;
    if (typeof drawer.showModal === "function") drawer.showModal();
    else drawer.setAttribute("open", "");
    /* Scroll lock no mesmo padrão do restante do tema (theme.js) */
    document.body.style.overflow = "hidden";
  }

  function bindFacetsDrawer() {
    var drawer = document.getElementById("facets-drawer");
    if (!drawer || drawer.dataset.facetsBound) return;
    drawer.dataset.facetsBound = "1";
    /* showModal cobre Escape; aqui restauramos scroll e devolvemos o foco ao botão que abriu */
    drawer.addEventListener("close", function () {
      document.body.style.overflow = "";
      var back = drawer.__lastFocus;
      if (back && document.contains(back)) back.focus();
      drawer.__lastFocus = null;
    });
    /* Clique no backdrop (área transparente do próprio dialog) fecha */
    drawer.addEventListener("click", function (e) {
      if (e.target === drawer) drawer.close();
    });
  }

  function validatePriceRange(form) {
    var min = form.querySelector("[data-facet-price-min]");
    var max = form.querySelector("[data-facet-price-max]");
    var status = form.querySelector('[data-facet-error]');
    if (status) { status.hidden = true; status.textContent = ''; }
    if (max) max.removeAttribute('aria-invalid');
    if (min) min.setCustomValidity("");
    if (max) max.setCustomValidity("");
    if (!min || !max || min.value === "" || max.value === "") return true;
    if (parseFloat(max.value) >= parseFloat(min.value)) return true;
    var message = max.dataset.invalidMessage || "O preço máximo deve ser maior ou igual ao mínimo.";
    max.setCustomValidity(message);
    max.setAttribute('aria-invalid', 'true');
    if (status) { status.textContent = message; status.hidden = false; }
    return false;
  }

  /* Handlers delegados no document: registrados uma única vez e sobrevivem a re-render da seção */
  if (!window.__joaninhaCollectionFacets) {
    window.__joaninhaCollectionFacets = true;

    /* Ordenação: preserva filtros da URL e remove page para voltar à primeira página */
    document.addEventListener("change", function (e) {
      var sel = e.target.closest("[data-sort]");
      if (!sel) return;
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", sel.value);
      url.searchParams.delete("page");
      window.location.href = url.toString();
    });

    /* Submit nativo GET: valida faixa de preço e omite inputs vazios da query */
    document.addEventListener("submit", function (e) {
      var form = e.target.closest("[data-facet-form]");
      if (!form) return;
      var priceInputs = Array.from(form.querySelectorAll('input[type="number"][data-facet-input]'));
      priceInputs.forEach(function (i) { i.disabled = false; i.setCustomValidity(""); });
      if (!validatePriceRange(form)) {
        e.preventDefault();
        form.querySelector("[data-facet-price-max]").reportValidity();
        return;
      }
      priceInputs.forEach(function (i) { if (i.value === "") i.disabled = true; });
    });

    /* A restrição depende dos dois campos; qualquer edição deve revalidar a faixa. */
    document.addEventListener("input", function (e) {
      var input = e.target.closest('[data-facet-form] input[type="number"]');
      if (input) validatePriceRange(input.closest("[data-facet-form]"));
    });

    document.addEventListener("click", function (e) {
      var toggle = e.target.closest("[data-filter-toggle]");
      if (toggle) {
        var drawer = document.getElementById("facets-drawer");
        if (drawer) openFacetsDrawer(drawer, toggle);
        return;
      }
      if (e.target.closest("[data-filter-close]")) {
        var d = document.getElementById("facets-drawer");
        if (!d) return;
        if (typeof d.close === "function") d.close();
        else d.removeAttribute("open");
        return;
      }
      if (e.target.closest("[data-filter-clear]")) {
        window.location.href = window.location.pathname;
        return;
      }
      /* Botão Aplicar fica no rodapé do drawer, fora do form: dispara o submit nativo do clone */
      var apply = e.target.closest("[data-filter-apply]");
      if (apply) {
        var dlg = apply.closest("dialog");
        var form = dlg && dlg.querySelector("[data-facet-form]");
        if (form) {
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
        }
      }
    });

    /* Re-vincula o dialog após re-render da seção no editor (sem duplicar listeners) */
    document.addEventListener("shopify:section:load", bindFacetsDrawer);
  }

  bindFacetsDrawer();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  document.querySelectorAll('[data-recover-toggle]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const login = document.querySelector('[data-od-id="main-login"] .account-card:not(.account-card--recover)');
      const recover = document.querySelector('[data-recover-form]');
      if (login && recover) {
        const isRecovering = recover.style.display === 'none';
        recover.style.display = isRecovering ? 'block' : 'none';
        login.style.display = isRecovering ? 'none' : 'block';
        (isRecovering ? recover : login).querySelector('input[type=email]')?.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-float"]) return;
  try {
    
  document.addEventListener('click', (e) => {
    const c = e.target.closest('[data-wa-close]');
    if (c) c.closest('.wa-float__balloon').style.display = 'none';
  });

  } catch(e) { console.error(e); }
})();
})();
